import { authenticated } from './WebRequest';
import type {
  ApiThunk,
  TranslationLanguage,
  TranslationProposalResponse,
  TranslationProposalPayload,
  TranslationProposalSaveResponse,
} from './types/Translations';

export type {
  ApiThunk,
  TranslationLanguage,
  TranslationProposal,
  TranslationProposalPayloadItem,
  TranslationProposalResponse,
  TranslationProposalPayload,
  TranslationProposalSaveResponse,
  TranslationProposalStatus,
} from './types/Translations';

export default class TranslationsAPI {
  static loadProposals(
    language: TranslationLanguage
  ): ApiThunk<TranslationProposalResponse> {
    return authenticated.get(`/translation_proposals/${language}`);
  }

  static proposeTranslations(
    payload: TranslationProposalPayload
  ): ApiThunk<TranslationProposalSaveResponse> {
    return authenticated.post('/translations/propose', payload);
  }
}
